import request from '@/services/interceptor.js'

export const get_annotazioniMezzo = (filtri) => {
    return request({ url: '/annotazionemezzo', method: 'get', params: filtri || {}, loadingBar: true })
}

export const create_annotazioneMezzo = (par) => {
    return request({ url: '/annotazionemezzo', method: 'post', data: par, loadingBar: true })
}

export const update_annotazioneMezzo = (id, par) => {
    return request({ url: `/annotazionemezzo/${id}`, method: 'put', data: par, loadingBar: true })
}

export const elimina_annotazioneMezzo = (id) => {
    return request({ url: `/annotazionemezzo/${id}`, method: 'delete', loadingBar: true })
}
